import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import {
    SovosBox,
    SovosMenuItem,
    SovosToolbar,
    SovosToolbarActions,
    SovosToolbarMoreMenu,
    SovosTypography,
} from "mosaic-react";
import { Delete, Edit } from "mosaic-react-icons";

import { handleDeleteTranslationDetailsRow } from "../../../../actions/UserActions/DatagridHandleUserActions";

export default function TranslationDetailsMoreAction(props) {
    const { i18n, deleteTranslationDetailsRowAction, pushDialog, pushNotification, reload } =
        useGlobalValue();
    const { value: cell } = props || {};
    const {
        translationId,
        setEditOpen,
        conditionsParsed,
        updatesParsed,
        cdmNames,
        translationTableBuilderId,
        entity,
        message,
    } = cell || {};
    return (
        <SovosBox>
            <SovosToolbar
                sx={{
                    backgroundColor: "transparent !important",
                }}
            >
                <SovosToolbarActions>
                    <SovosToolbarMoreMenu>
                        <SovosMenuItem
                            onClick={() =>
                                handleDeleteTranslationDetailsRow(
                                    {
                                        deleteTranslationDetailsRowAction,
                                        id: translationTableBuilderId,
                                        translationId,
                                        pushDialog,
                                        i18n,
                                        reload,
                                    },
                                    pushNotification,
                                )
                            }
                        >
                            <Delete />
                            <SovosTypography children={i18n`Delete`} variant={"span"} />
                        </SovosMenuItem>
                        <SovosMenuItem
                            onClick={() => {
                                setEditOpen({
                                    status: true,
                                    row: {
                                        conditionsParsed,
                                        updatesParsed,
                                        translationTableBuilderId,
                                        translationId,
                                        related_entities: JSON.stringify([entity]),
                                    },
                                    message,
                                    cdmNames,
                                });
                            }}
                        >
                            <Edit />
                            <SovosTypography children={i18n`Edit`} variant={"span"} />
                        </SovosMenuItem>
                    </SovosToolbarMoreMenu>
                </SovosToolbarActions>
            </SovosToolbar>
        </SovosBox>
    );
}
